import React, { useCallback } from 'react'
import {
    Card, CardBody, CardHeader, CardIcon, CardTitle, FbButton,
    GridContainer,
    GridItem,
    Icons, Table
} from '@fabricks/ui-components'
import { useKeycloak } from "react-keycloak";
import { useHistory } from "react-router-dom";
import ChartistGraph from "react-chartist";
import styled from "styled-components";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import PackagetypesTable from "../Packagetypes/PackagetypesTable";
import BoxtypesTable from "../Boxtypes/BoxtypesTable";
import Navigation from "../../constants/navigation";
import { HR } from "../../components/Common/Common";

interface BoxtypesPageProps {
}

export const Boxtypes: React.FC = (props: BoxtypesPageProps) => {
    const [keycloak] = useKeycloak()
    const history = useHistory()

    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <FbButton variant="contained" color="primary" onClick={() => history.push(Navigation.BoxtypesCreate.path)}>
                    <Icons.Add />
                </FbButton>
                <HR />
                <BoxtypesTable />
            </GridItem>
        </GridContainer>
    )
}
